const { client } = require('../../MbaasClient')

export const funcCreateDefault = async (resource, params) => {
  const { data } = await client.getTable(resource).insert(params.data)
  return { data: data }
}
